module.exports = __webpack_public_path__ + "images/bannerES-8cba7c3d50db43afa306b5e01e44f4e0.png";